import CountryPageTemplate from './CountryPageTemplate';

export default function HungaryPage() {
  return <CountryPageTemplate countryKey="hu" />;
}